var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyTeamsHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 60,
    fill: "#F3E6F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 65C82.5 69.1421 79.1423 72.5 75 72.5C70.8579 72.5 67.5 69.1421 67.5 65C67.5 60.8579 70.8579 57.5 75 57.5C79.1423 57.5 82.5 60.8579 82.5 65Z",
    fill: "#870091"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 70C95 72.7614 92.7615 75 90 75C87.2385 75 85 72.7614 85 70C85 67.2386 87.2385 65 90 65C92.7615 65 95 67.2386 95 70Z",
    fill: "#870091"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85 87.5C85 81.9772 80.5227 77.5 75 77.5C69.4771 77.5 65 81.9772 65 87.5V95H85V87.5Z",
    fill: "#870091"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65 70C65 72.7614 62.7614 75 60 75C57.2386 75 55 72.7614 55 70C55 67.2386 57.2386 65 60 65C62.7614 65 65 67.2386 65 70Z",
    fill: "#870091"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90 95V87.5C90 84.8647 89.3205 82.388 88.1267 80.2358C88.7255 80.0818 89.3532 80 90 80C94.1422 80 97.5 83.3577 97.5 87.5V95H90Z",
    fill: "#870091"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8732 80.2358C60.6796 82.388 60 84.8647 60 87.5V95H52.5V87.5C52.5 83.3577 55.8579 80 60 80C60.6468 80 61.2744 80.0818 61.8732 80.2358Z",
    fill: "#870091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTeamsHover);
export default __webpack_public_path__ + "static/media/MyTeams-hover.a6fb35f91b19fd6e8acbdccefe895055.svg";
export { ForwardRef as ReactComponent };